import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AxonComponent } from '../axon.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { Location } from '@angular/common';
import * as es6printJS from "print-js";
import { allowPreviousPlayerStylesMerge } from '@angular/animations/browser/src/util';
import { HttpReportService } from '../services/http/http-report.service';


@Component({
	selector: 'app-report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.scss']
})
export class ReportComponent extends AxonComponent implements OnInit, OnDestroy {
	subtitle: string;
    iframeUrl: SafeResourceUrl;

    queryParamsSubscription: Subscription;

    title: string;
    orgName: string;

    @ViewChild('iframeRef') iframeRef: ElementRef;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private _location: Location,
		private httpReportService: HttpReportService,
		) {
		super();
		this.subtitle = 'This is some text within a card block.';
		// this.routeParamsSubscription = this.route.params.subscribe( params => {
		// 	console.log('Params: ' + JSON.stringify( params ) );
		// 	this.initMetabase(parseInt(params.id, 10));
        // });
        this.queryParamsSubscription = this.route.queryParams.subscribe( queryParams => {
            console.log('Query Params: ' + JSON.stringify( queryParams ) );

            const reportId = parseInt(queryParams.id, 10);
            let orgId = null;
            if ( queryParams.org_id ) {
                orgId = parseInt(queryParams.org_id, 10);
            }

            if ( queryParams.title ) {
                this.title = queryParams.title;
            }

            if ( queryParams.org_name ) {
                this.orgName = queryParams.org_name;
            }

			this.initMetabase(reportId, orgId);
		});
  }

	ngOnInit() {
		// this.initMetabase();
    }

    ngOnDestroy() {
        if ( this.queryParamsSubscription ) {
            this.queryParamsSubscription.unsubscribe();
        }
    }

	private initMetabase(reportId: number, orgId: number) {
		const METABASE_SITE_URL = environment.metabase_url; /* Axon Local Server */

		this.httpReportService.getDashboardEmbedToken(reportId, orgId).subscribe(
			response => {
				this.iframeUrl = this.sanitiseResource(METABASE_SITE_URL + "/embed/dashboard/" + response.token + "#bordered=false&titled=false");
				console.log('URL: ' + this.iframeUrl);
			},
			err => {
				console.log('Error loading metabase embed token', err);
			}
		);
	}
	backClicked() {
		this._location.back();
	}

	scrapePrint() {
		es6printJS("iframe", "html");
	}
}

